import * as Yup from 'yup';
import { PATRON_CONTRASENA } from 'src/utils/patronesValidacion';

// Objetos de inicialización y validación para el formulario de registro de usuarios externos
export const valoresInicialesRegistroExternos = {
	tipoIdentifiacion: '',
	identificacion: '',
	nombres: '',
	apellidos: '',
	correo: '',
	confirmarCorreo: '',
	unidadId: '',
	celular: '',
	correoAlterno: '',
	contrasena: '',
	confirmaContrasena: '',
	aceptaTerminos: false,
};

export const esquemaDeValidacionRegistroExternos = Yup.object({
	tipoIdentificacion: Yup.string().required('El tipo de documento es obligatorio'),
	identificacion: Yup.string().required('El documento es obligatorio'),
	nombres: Yup.string().required('El nombre es obligatorio'),
	apellidos: Yup.string().required('Los apellidos son obligatorio'),
	unidadId: Yup.string().required('La dependencia es obligatoria'),
	// El correo no puede finalizar con dominio: udea.edu.co
	correo: Yup.string()
		.email('Email no válido')
		.matches(/(?<!udea\.edu\.co)$/, 'El correo no puede ser institucional')
		.required('El correo es obligatorio'),
	confirmarCorreo: Yup.string()
		.oneOf([Yup.ref('correo')], 'El correo no coincide')
		.required('La confirmación del correo es obligatoria'),
	contrasena: Yup.string()
		.matches(
			PATRON_CONTRASENA,
			'La contraseña debe tener al menos 8 caracteres que incluyan mayúsculas, minúsculas, números y un carácter no alfanumérico'
		)
		.required('La contraseña es obligatoria'),
	celular: Yup.string().required('El celular es obligatorio'),
	confirmaContrasena: Yup.string().oneOf([Yup.ref('contrasena')], 'Las contraseñas no coinciden').required('La confirmación de la contraseña es obligatoria'),
	aceptaTerminos: Yup.boolean().oneOf([true], 'Debes aceptar'),
});

// Objetos de inicialización y validación para el formulario de registro de usuarios internos
export const valoresInicialesRegistroInternos = {
	tipoIdentificacion: '',
	identificacion: '',
	nombres: '',
	apellidos: '',
	correo: '',
	confirmarCorreo: '',
	unidadId: '',
	celular: '',
	correoAlterno: '',
	aceptaTerminos: false,
};

export const esquemaDeValidacionRegistroInternos = Yup.object({
	tipoIdentificacion: Yup.string().required('El tipo de documento es obligatorio'),
	identificacion: Yup.string().required('El documento es obligatorio'),
	nombres: Yup.string().required('El nombre es obligatorio'),
	apellidos: Yup.string().required('Los apellidos son obligatorio'),
	unidadId: Yup.string().required('La unidad es obligatoria'),
	correo: Yup.string().email('Email no válido').matches(/@udea\.edu\.co$/, 'El correo debe ser institucional').required('El correo es obligatorio'),
	confirmarCorreo: Yup.string()
		.oneOf([Yup.ref('correo')], 'El correo institucional no coincide')
		.required('La confirmación del correo es obligatoria'),
	celular: Yup.string().required('El teléfono es obligatorio'),
	aceptaTerminos: Yup.boolean().oneOf([true], 'Debes aceptar'),
});

